import client from '../httpClient';

const holidayGetOperationTimeApi = (userId) => {
  const GET_HOLIDAY_OPERATION_TIME_URL = `/holiday/operation/time/${userId}`;
  return client.get(GET_HOLIDAY_OPERATION_TIME_URL, String(userId), { isShowLoading: false });
};

export default holidayGetOperationTimeApi;
